<template>
  <div v-loading.fullscreen="loading" element-loading-text="加载中">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="searchParam" @search="search" @reset="reset" />
    </el-card>
    <el-card>
      <el-table ref="dataTable" :height="heightStyleObj" :data="pageListData" highlight-current-row border >
        <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
          <template slot-scope="{ $index }">
            {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="orderNo" width="160px" label="单据编号" />
        <el-table-column show-overflow-tooltip prop="busiType" min-width="100px" label="业务类型" >
          <template slot-scope="scope">
            <dict-tag :options="dictObj.cancelType" :value="scope.row.busiType" />
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="materialCode" min-width="120px" label="物料编码">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="materialName" min-width="120px" label="物料名称">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="materialSpecifications" width="140px" label="物料规格型号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="batchNo" width="120px" label="批号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="cause" width="200px" label="报废原因">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="quantity" width="120px" label="报废数量" />
        <el-table-column show-overflow-tooltip prop="createBy" min-width="120px" label="操作人"/>
        <el-table-column show-overflow-tooltip prop="createTime" sortable="custom" width="150px" label="操作时间">
          <template slot-scope="{ row }">
            {{ row.createTime ? parseTime(row.createTime, '{y}-{m}-{d} {h}:{i}:{s}') : null }}
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="180" align="center">
          <template slot-scope="{ row }">
            <el-button  type="text" @click="handlePreview(row)">查看UDI码</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
                  :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
    </el-card>

    <cancelCodeList v-if="previewShow" :dict-obj="dictObj" :visible="previewShow" :inventory-info="inventoryInfo"
                     @close="close">
    </cancelCodeList>
  </div>
</template>

<script>
import { getDict } from '@/api/common'
import { getCancelPage } from '@/api/cancel'
import cancelCodeList from "./components/cancelCodeList.vue";

export default {
  components: {
    cancelCodeList,
  },
  data() {
    return {
      heightStyleObj: '',
      loading: true, // 遮罩
      previewShow: false,
      pageListData: [], // 列表数据
      searchParam: { // 查询参数
        pageNum: 1,
        pageSize: 10,
        total: 0,
        isAsc: '',
        orderByColumn: 'T1.update_time'
      },
      dictObj: {
        cancelType: []
      },
      inventoryInfo:'',
      queryItems: [
        {
          label: '关键字',
          field: 'searchValue',
          placeholder: '单据编号/报废原因/物料编码/物料名称/物料规格型号',
          width: '400px',
          type: 'input'
        },
        {
          label: '业务类型',
          field: 'cancelType',
          type: 'select',
          options: []
        },
        {
          label: '报废时间',
          field: 'createTime',
          type: 'date',
        },
      ],
    }
  },


  created() {
    this.getPageListData()
    this.getDicts(['cancelType'])
  },
  methods: {
    handlePreview(row) {
      this.previewShow = true
      this.inventoryInfo = JSON.parse(JSON.stringify(row))
    },
    close() {
      this.previewShow = false
      this.getPageListData()
    },
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {
          this.dictObj[dictType] = res.rows
          if (dictType === 'cancelType') {
            const findIndex = this.queryItems.findIndex(item => item.field === dictType)
            this.queryItems[findIndex].options = JSON.parse(JSON.stringify(res.rows))
          }
        })
      })
    },
    // 查询
    search() {
      this.searchParam.pageNum = 1
      this.getPageListData()
    },
    // 重置查询
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },

    // 获取列表数据
    getPageListData() {
      this.loading = true
      const searchParam = JSON.parse(JSON.stringify(this.searchParam))
      if (searchParam.createTime) {
        const [startTime, endTime] = searchParam.createTime
        searchParam.startTime = startTime
        searchParam.endTime = endTime
        delete searchParam.createTime
      }
      getCancelPage(searchParam).then(res => {
        this.searchParam.total = res.total
        this.pageListData = res.rows
      }).finally(() => {
        this.loading = false
      })
    },

  }
}
</script>
